
/**
 * Load and configure site radial menus.
 *
 * @file radial-menu.js
 * @author Dan Griffin
 */

// import './vendor/wheelnav.js'

// function selectTab(identifier) {
//   const $jq = jQuery.noConflict()
//   const $tab = $jq(`#${identifier}`)

//   if (!$tab.length) {
//     return
//   }

//   if (typeof $jq.fn.tab === 'function') {
//     $tab.tab('show')
//   } else {
//     console.error('[CircleGraph] Bootstrap tab plugin is unavailable')
//   }
// }

// // window.selectTab = selectTab

// document.addEventListener('DOMContentLoaded', () => {
//   const blocks = document.querySelectorAll('.block__circleGraph')

//   blocks.forEach((block) => {
//     const wheelGraph = block.querySelector('.circleGraph__graph')
//     const tabList = block.querySelector('#circle-tabs')

//     if (!wheelGraph || !tabList) {
//       console.warn('[CircleGraph] Graph or tab list not found', block)
//       return
//     }

//     if (!wheelGraph.id) {
//       let counter = 0
//       let id

//       do {
//         id = `circleGraph--${counter++}`
//       } while (document.getElementById(id))

//       wheelGraph.id = id
//     }

//     let wheel

//     try {
//       wheel = new wheelnav(wheelGraph.id)
//     } catch (error) {
//       console.error('[CircleGraph] Constructor failed:', error)
//       return
//     }

//     if (!wheel.navItems || !Array.isArray(wheel.navItems)) {
//       console.error(
//         '[CircleGraph] navItems was not initialized',
//         wheelGraph.id,
//         wheel
//       )
//       return
//     }

//     wheel.spreaderRadius = wheel.wheelRadius * 0.35
//     wheel.clockwise = true
//     wheel.wheelRadius *= 0.83

//     try {
//       wheel.createWheel()
//     } catch (error) {
//       console.error(
//         '[CircleGraph] createWheel failed:',
//         wheelGraph.id,
//         error
//       )
//       return
//     }

//     const tabs = Array.from(
//       tabList.querySelectorAll('.nav-link')
//     )

//     let selectedTab = tabs.find((tab) =>
//       tab.classList.contains('active')
//     )?.id || tabs[0]?.id

//     const debounce = (callback, delay) => {
//       let timeoutId

//       return (...args) => {
//         clearTimeout(timeoutId)
//         timeoutId = setTimeout(() => callback(...args), delay)
//       }
//     }

//     const debouncedSelect = debounce((tabId) => {
//       if (tabId) {
//         document.getElementById(tabId)?.click()
//       }
//     }, 250)

//     wheel.navItems.forEach((item, index) => {
//       const tab = tabs[index]

//       if (!tab || !item.navSlice) {
//         return
//       }

//       const tabId = tab.id

//       item.navSlice.mouseover(() => {
//         debouncedSelect(tabId)
//       })

//       item.navSlice.mouseout(() => {
//         debouncedSelect(selectedTab)
//       })

//       item.navSlice.mousedown(() => {
//         selectedTab = tabId
//         document.getElementById(tabId)?.click()
//       })
//     })

//     tabList.classList.add('init')
//   })
// })


(() => {
    'use strict';

    const SVG_NS = 'http://www.w3.org/2000/svg';

    const createSvgElement = (tag, attributes = {}) => {
        const element = document.createElementNS(SVG_NS, tag);

        Object.entries(attributes).forEach(([name, value]) => {
            element.setAttribute(name, String(value));
        });

        return element;
    };

    const polarPoint = (cx, cy, radius, angle) => {
        const radians = (angle * Math.PI) / 180;

        return {
            x: cx + radius * Math.cos(radians),
            y: cy + radius * Math.sin(radians),
        };
    };

    const createDonutPath = (startAngle, endAngle) => {
        const cx = 200;
        const cy = 200;
        const outerRadius = 185;
        const innerRadius = 100;

        const startOuter = polarPoint(cx, cy, outerRadius, startAngle);
        const endOuter = polarPoint(cx, cy, outerRadius, endAngle);
        const startInner = polarPoint(cx, cy, innerRadius, startAngle);
        const endInner = polarPoint(cx, cy, innerRadius, endAngle);

        const largeArc = endAngle - startAngle > 180 ? 1 : 0;

        return [
            `M ${startOuter.x} ${startOuter.y}`,
            `A ${outerRadius} ${outerRadius} 0 ${largeArc} 1 ${endOuter.x} ${endOuter.y}`,
            `L ${endInner.x} ${endInner.y}`,
            `A ${innerRadius} ${innerRadius} 0 ${largeArc} 0 ${startInner.x} ${startInner.y}`,
            'Z',
        ].join(' ');
    };

    const initCircleGraph = (root) => {
        const svg = root.querySelector('[data-circle-graph-svg]');
        const content = root.querySelector('[data-circle-graph-content]');
        const sourceItems = Array.from(
            root.querySelectorAll('[data-circle-graph-item]')
        );

        if (!svg || !content || !sourceItems.length) {
            return;
        }

        if (root.dataset.circleGraphInitialized == 'true') {
            return;
        }

        root.dataset.circleGraphInitialized = 'true';

        const items = sourceItems.map((source, index) => ({
            index,
            title: source.dataset.title || `Topic ${index + 1}`,
            icon: source.dataset.icon || '',
            html:
                source.querySelector(
                    '[data-circle-graph-item-content]'
                )?.innerHTML || '',
        }));

        const groups = [];
        const count = items.length;
        const segmentAngle = 360 / count;
        const gap = Math.min(2, segmentAngle * 0.15);
        let activeIndex = 0;

        svg.replaceChildren();

        const segmentLayer = createSvgElement('g', {
            class: 'circle-graph__segments',
        });

        const iconLayer = createSvgElement('g', {
            class: 'circle-graph__icons',
            'aria-hidden': 'true',
        });

        svg.append(segmentLayer, iconLayer);

        items.forEach((item, index) => {
            const startAngle = -90 + index * segmentAngle + gap / 2;
            const endAngle = -90 + (index + 1) * segmentAngle - gap / 2;
            const middleAngle = -90 + (index + 0.5) * segmentAngle;

            const group = createSvgElement('g', {
                class: 'circle-graph__segment',
                role: 'button',
                tabindex: index == 0 ? '0' : '-1',
                'aria-label': item.title,
                'aria-pressed': 'false',
                'data-index': index,
            });

            const path = createSvgElement('path', {
                class: 'circle-graph__segment-path',
                d: count == 1
                    ? [
                        'M 200 15',
                        'A 185 185 0 1 1 200 385',
                        'A 185 185 0 1 1 200 15',
                        'M 200 100',
                        'A 100 100 0 1 0 200 300',
                        'A 100 100 0 1 0 200 100',
                        'Z',
                    ].join(' ')
                    : createDonutPath(startAngle, endAngle),
                'fill-rule': 'evenodd',
            });

            group.appendChild(path);
            segmentLayer.appendChild(group);
            groups.push(group);

            if (item.icon) {
                const iconPosition = polarPoint(
                    200,
                    200,
                    140,
                    middleAngle
                );

                const icon = createSvgElement('image', {
                    class: 'circle-graph__icon',
                    x: iconPosition.x - 19,
                    y: iconPosition.y - 19,
                    width: 38,
                    height: 38,
                    preserveAspectRatio: 'xMidYMid meet',
                });

                icon.setAttribute('href', item.icon);
                iconLayer.appendChild(icon);
            }
        });

        svg.appendChild(
            createSvgElement('circle', {
                cx: 200,
                cy: 200,
                r: 96,
                fill: '#fff',
                'pointer-events': 'none',
            })
        );

        svg.insertBefore(svg.lastChild, iconLayer);

        const selectItem = (index, moveFocus = false) => {
            activeIndex = (index + count) % count;

            groups.forEach((group, groupIndex) => {
                const isActive = groupIndex == activeIndex;

                group.classList.toggle('is-active', isActive);
                group.setAttribute('aria-pressed', String(isActive));
                group.setAttribute('tabindex', isActive ? '0' : '-1');
            });

            const item = items[activeIndex];

            content.replaceChildren();

            const heading = document.createElement('h3');
            heading.className = 'circle-graph__heading';
            heading.textContent = item.title;

            const body = document.createElement('div');
            body.className = 'circle-graph__body';
            body.innerHTML = item.html;

            content.append(heading, body);

            if (moveFocus) {
                groups[activeIndex].focus();
            }
        };

        groups.forEach((group, index) => {
            group.addEventListener('click', () => {
                selectItem(index);
            });

            group.addEventListener('keydown', (event) => {
                let nextIndex = null;

                switch (event.key) {
                    case 'ArrowRight':
                    case 'ArrowDown':
                        nextIndex = activeIndex + 1;
                        break;

                    case 'ArrowLeft':
                    case 'ArrowUp':
                        nextIndex = activeIndex - 1;
                        break;

                    case 'Home':
                        nextIndex = 0;
                        break;

                    case 'End':
                        nextIndex = count - 1;
                        break;

                    case 'Enter':
                    case ' ':
                        event.preventDefault();
                        selectItem(index);
                        return;

                    default:
                        return;
                }

                event.preventDefault();
                selectItem(nextIndex, true);
            });
        });

        selectItem(0);
    };

    const init = () => {
        document.querySelectorAll('.circle-graph').forEach(initCircleGraph);
    };

    if (document.readyState == 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();